import React, { Component } from 'react';

import './styles/modalErrorPayment.scss';

export default class ModalErrorPayment extends Component {
  render() {
    return (
      <div className="modal-error">
        <div className="modal-error__text">
          <p>Что-то пошло не&nbsp;так, но&nbsp;твои данные направлены менеджеру. Мы&nbsp;свяжемся с&nbsp;тобой в&nbsp;ближайшее время.</p>
          <a href="/" className="btn _type-2">Вернуться на главную</a>
        </div>
      </div>
    )  
  }
}